import React from 'react';
import config from 'react-global-configuration';

import {
  LanguageSwitcher,
} from '@uncinc/react-drupal-core';

import './style.scss';

const LanguageSwitchWrapper = () => {
  const languages = config.get('LANGUAGES');
  const defaultLanguage = config.get('DEFAULT_LANGUAGE');

  return (
    <div className="LanguageSwitchWrapper">
      <LanguageSwitcher languages={languages} defaultLanguage={defaultLanguage} hideActive />
    </div>
  );
};

export default LanguageSwitchWrapper;
